"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    RedeemStrategy: {
      _enum: {
        Immediately: 'Null',
        Target: 'EraIndex',
        WaitForUnbonding: 'Null'
      }
    }
  }
};
exports.default = _default;